import { Directive } from '@angular/core';
import { AbstractControl, FormGroup, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { Console } from 'console';

@Directive({
  selector: '[aimsAutoreorderDirective]',
  providers: [ { provide: NG_VALIDATORS, useExisting: AutoreorderDirective, multi: true }]
})
export class AutoreorderDirective implements Validator {

  constructor() { }

  validate(control: AbstractControl): ValidationErrors | null {
    let autoReorderControl = control.get('Auto-Reorder');
    if (autoReorderControl) {
      let autoReorder = autoReorderControl.value;
      if (autoReorder) {
        let minQtyControl = control.get('Minimum Quantity');
        let minQty = minQtyControl.value;

        let authorizedQtyControl = control.get('Authorized Quantity');
        let authorizedQty = authorizedQtyControl.value;
        if ((!minQty || minQty == 0) || (!authorizedQty || authorizedQty == 0)) {
          return { autoreorder: true }
        }
      }
    }
    return null;
  }

  // registerOnValidatorChange?(fn: () => void): void {
  //   throw new Error('Method not implemented.');
  // }

}
